/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Watchpage_Meta_TitleInputs */

const en_fw_watchpage_meta_title = /** @type {(inputs: Fw_Watchpage_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where to Watch Firefly Wedding Anime (2026): Streaming & Schedule`)
};

const zh_fw_watchpage_meta_title = /** @type {(inputs: Fw_Watchpage_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画在哪看（2026）：播出平台与时间表`)
};

/**
* | output |
* | --- |
* | "Where to Watch Firefly Wedding Anime (2026): Streaming & Schedule" |
*
* @param {Fw_Watchpage_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_watchpage_meta_title = /** @type {((inputs?: Fw_Watchpage_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Watchpage_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_watchpage_meta_title(inputs)
	return zh_fw_watchpage_meta_title(inputs)
});
export { fw_watchpage_meta_title as "fw.watchpage.meta_title" }